const animatedHeader = document.querySelector('store-header[sticky][animated]');

if(animatedHeader) {

    let lastScrollTop = 0;
    let scrollingDown = false;
    let scrollingUp = false;
    const animatedHeaderSection = animatedHeader.parentNode;
    animatedHeaderSection.style.transition = 'top .3s cubic-bezier(0.34, 0.01, 0.56, 1)';

    const headerHeight = animatedHeaderSection.offsetHeight;

    window.addEventListener('scroll', function headerAnimation(event) {
        if (window.scrollY > lastScrollTop) {
            if (!scrollingDown) {
                scrollingDown = true;
                scrollingUp = false;
                animatedHeaderSection.style.top = -headerHeight + "px"

            }
        } else if (window.scrollY < lastScrollTop) {
            if (!scrollingUp) {
                scrollingUp = true;
                scrollingDown = false;
                animatedHeaderSection.style.top = 0
            }
        }

        lastScrollTop = window.scrollY;
    });
}